// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__d2T6Y","label":"Checkbox_label__sIWjc","disabled":"Checkbox_disabled__Yl_mr","labelText":"Checkbox_labelText__61Vbh"};